export const protocolsStrings = {
  pageTitle: 'Protocolos',
  newButton: 'Nuevo protocolo',
  emptyTitle: 'Sin protocolos todavía',
  emptyDescription: 'Crea tu primer protocolo a partir de una plantilla.',
  emptyCta: 'Nuevo protocolo',
  emptySearch: 'No hay protocolos que coincidan con tu búsqueda.',
  listUpdated: 'Actualizado',
  listVersion: (n: number) => `v${n}`,
  loading: 'Cargando protocolos...',
  error: 'No se pudo cargar los protocolos.',
  errorTitle: 'Error al cargar protocolos',
  retryButton: 'Reintentar',
  searchPlaceholder: 'Buscar protocolos…',
  filterAllTypes: 'Todos los tipos',
  filterFavorites: 'Favoritos',
  sortUpdatedDesc: 'Más reciente',
  sortUpdatedAsc: 'Más antiguo',
  sortTitleAsc: 'A → Z',
  sortTitleDesc: 'Z → A',
  favoriteAdd: 'Añadir a favoritos',
  favoriteRemove: 'Quitar de favoritos',
  archiveButton: 'Archivar protocolo',
  archiveTitle: 'Archivar protocolo',
  archiveBody: (title: string) =>
    `¿Archivar "${title}"? El protocolo ya no aparecerá en la lista principal.`,
  archiveConfirmButton: 'Archivar',
  archivingButton: 'Archivando...',
} as const
